import { render, staticRenderFns } from "./tabZfdetails2.vue?vue&type=template&id=294f7e56&"
import script from "./tabZfdetails2.vue?vue&type=script&lang=js&"
export * from "./tabZfdetails2.vue?vue&type=script&lang=js&"
import style0 from "./tabZfdetails2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZfdetails2.vue"
export default component.exports